module.exports = __webpack_public_path__ + "static/assets/ff453c8f7c2abed5ac010927039926b5.png";